exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card[data-v-2f28e83b] {\n  width: 60%;\n  margin: auto;\n  padding: 1rem 5rem;\n}\n.btn[data-v-2f28e83b] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n", ""]);

// exports
